import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { NameSurname, Status } from "./contactlistCol";


//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import jsPDF from "jspdf";
import "jspdf-autotable";
import Dropzone from 'react-dropzone-uploader';

import {
  getAdvertesing_Form as onGetCampain,
  addAdvertesing_Form as onAddCampain,
  updateAdvertesing_Form as onUpdateCampain,
  deleteAdvertesing_Form as onDeleteCampain,
} from "store/contacts/actions";
import { isEmpty } from "lodash";


//redux
import { useSelector, useDispatch } from "react-redux";

const ContactsList = props => {
  const tableRef = useRef(null);

  //meta title
  document.title = "REKLAM | BERLİN ESNAF ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();
  const [getFileName, setFileName] = useState('');


  const [getFileSubMedia, setFileSubMedia] = useState([]);

  const [getSubMediaID, setSubMediaID] = useState();

  const [getFileSubMediaAdd, setFileSubMediaAdd] = useState([]);
  const [getIsActive, setIsActive] = useState(false);

  // validation

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      title: (contactEdit && contactEdit.Advertesing_Form_CompanyName) || "",

      link: (contactEdit && contactEdit.Campain_Link) || "",

      discount: (contactEdit && contactEdit.Discount) || "",
      sort: (contactEdit && contactEdit.Sort) || "",


      com: (contactEdit && contactEdit.CommissionPercentage) || "",
      maks: (contactEdit && contactEdit.Campain_Maks_Users) || "",
      min: (contactEdit && contactEdit.Campain_MinUsers) || "",
      sort: (contactEdit && contactEdit.Sort) || "",
    },
    validationSchema: Yup.object({
      title: Yup.string(3).required("Başlığı Giriniz"),


    }),
    onSubmit: values => {
      if (isEdit) {

        const updateUser = {
          ID: contactEdit.ID,
          Advertesing_Form_CompanyName: values.title,
          Advertesing_Category_ID: getCategoryID,

  
          Advertesing_Form_Image: getFileName,
          Advertesing_Active: getIsActive,

          News_ID:getNewsID,
          Forum_ID:getForumID,
          Job_Advertisement_ID:getJobAdvID,
         // Sort : values.sort


        };
        dispatch(onUpdateCampain(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {
        const newUser = {
          Advertesing_Form_CompanyName: values["title"],
          Advertesing_Category_ID: getCategoryID,
       
        //  Sort : values["sort"],

        
          Advertesing_Form_Image: getFileName,
          Advertesing_Active: getIsActive,
        
          News_ID:getNewsID,
          Forum_ID:getForumID,
          Job_Advertisement_ID:getJobAdvID
        };
        // save new user
        dispatch(onAddCampain(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.advertesingform,
  }));

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);

  const [isEdit, setIsEdit] = useState(false);


  const [getCategoryID, setCategoryID] = useState(null);
  const [getCategory, setCategory] = useState([]);

  const [getJobAdvID, setJobAdvID] = useState(null);
  const [getForumID, setForumID] = useState(null);
  const [getNewsID, setNewsID] = useState(null);

  const [getNews, setNews] = useState([]);
  const [getForum, setForum] = useState([]);
  const [getJobAdv, setJobAdv] = useState([]);


  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
      {
        Header: "ID",
        accessor: "ID",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "Sıra No",
        accessor: "Sort",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
      {
        Header: "Foto",
        // accessor: "name",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <>
            {!cellProps.Advertesing_Form_Image ? (
              <div className="avatar-xs">
                {cellProps.Advertesing_Form_CompanyName != null ? <span className="avatar-title rounded-circle">
                  {cellProps.Advertesing_Form_CompanyName.charAt(0)}
                </span> : null}
              </div>
            ) : (
              <div className="avatar-xl">
                <img
                 className="avatar-xl"
                  src={'http://berlinadmin.stechomeyazilim.info' + cellProps.Advertesing_Form_Image}
                  alt=""
                />
              </div>
            )}
          </>
        ),
      },
      {
        Header: "Firma",
        accessor: "Advertesing_Form_CompanyName",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "Mail",
        accessor: "Advertesing_Form_MailAdress",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "Telefon",
        accessor: "Advertesing_Phone",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
      {
        Header: "Kategori",
        accessor: "Advertesing_Category.Advertesing_Category_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
     
     
      {
        Header: "Aktif Mi?",
        accessor: "Advertesing_Active",
        filterable: true,
        Cell: cellProps => {
          return <Status {...cellProps} />;
        },
      },

      {
        Header: "Forum",
        accessor: "Forum.Forum_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "Haber",
        accessor: "News.News_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "İlan",
        accessor: "Job_Advertisement.Job_Advertisement_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },


      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">


              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserClick(userData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );



  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetCampain());
      setIsEdit(false);
    }
  }, [dispatch, users]);

  useEffect(() => {
    setContact(users);
    // setIsEdit(false);
  }, [users]);

  useEffect(() => {
    if (!isEmpty(users) && !!isEdit) {
      setContact(users);
      //setIsEdit(false);
    }
  }, [users]);

  const toggle = () => {
    setModal(!modal);
  };


  const handleUserClick = (arg) => {
    const user = arg;

    setEditContact(user);
    setIsEdit(true);

    setCategoryID(user.Advertesing_Category_ID)

    setIsActive(user.Advertesing_Active)

    setFileName(user.Advertesing_Form_Image)
 
    setForumID(user.Forum_ID)
    setJobAdvID(user.Job_Advertisement_ID)
    setNewsID(user.News_ID)

    toggle();
  };




  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteCampain(contact.ID));
    }
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    toggle();
  };

  const _setChoiceCategory = arg => {
    setCategoryID(arg.target.value)
  }

  const _setChoiceCategorySecond = arg => {
    setCategoryIDSecond(arg.target.value)
  }
  const _setChoiceCategoryThird = arg => {
    setCategoryIDThird(arg.target.value)
  }

  const _setChoiceCategoryForth = arg => {
    setCategoryIDForth(arg.target.value)
  }
  const _setChoiceCategoryFifth = arg => {
    setCategoryIDFifth(arg.target.value)
  }
  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }



  const getUploadParams = ({ file }) => {
    const body = new FormData();
    body.append('dataFile', file);
    return { url: 'https://monoadmin.stechomeyazilim.info:8081/uploadfile', body }
  }


  const handleChangeStatusBanner = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response)
          console.log("lnslkdf", result.file)
          setFileSubMediaAdd(oldArray => [{ fileName: result.file.filename, fileType: result.file.mimetype }, ...oldArray]);
        }
      }
    }
  }
  const handleChangeStatus = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileName(result.file.filename)

        }
      }
    }
  }



  const _setChoiceNews = arg => {
    setNewsID(arg.target.value)
  }
  const _setChoiceForum = arg => {
    setForumID(arg.target.value)
  }

  const _setChoiceJobAdv = arg => {
    setJobAdvID(arg.target.value)
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Reklam Listesi" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>


                  <TableContainer
                    columns={columns}
                    data={users}
                    ref={tableRef}
                    isGlobalFilter={true}
                    isAddAdvertesing={true}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />

          
                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Düzenle" : "Reklam Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>


                          <div className="mb-3">
                              <Label className="form-label">Haber Seçiniz</Label>
                              <Input
                                name="paymentStatus"
                                type="select"
                                className="form-select"
                                defaultValue={getNewsID}
                                onChange={(text) => _setChoiceNews(text)}
                                value={
                                  getNewsID
                                }>
                                  <option value="">Lütfen Seçim Yapınız</option>

                                {getNews.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.News_Title}</option>
                                ))}

                              </Input>
                             
                            </div>


                            <div className="mb-3">
                              <Label className="form-label">Forum Seçiniz</Label>
                              <Input
                                name="paymentStatus"
                                type="select"
                                className="form-select"
                                defaultValue={getForumID}
                                onChange={(text) => _setChoiceForum(text)}
                                value={
                                  getForumID
                                }>
                                  <option value="">Lütfen Seçim Yapınız</option>

                                {getForum.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.Forum_Title}</option>
                                ))}

                              </Input>
                             
                            </div>


                            <div className="mb-3">
                              <Label className="form-label">İlan Seçiniz</Label>
                              <Input
                                name="paymentStatus"
                                type="select"
                                className="form-select"
                                defaultValue={getJobAdvID}
                                onChange={(text) => _setChoiceJobAdv(text)}
                                value={
                                  getJobAdvID
                                }>
                                  <option value="">Lütfen Seçim Yapınız</option>

                                {getJobAdv.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.Job_Advertisement_Title}</option>
                                ))}

                              </Input>
                             
                            </div>


                            <div className="mb-3">
                              <Label className="form-label">Reklam Kategori Seçiniz</Label>
                              <Input
                                name="paymentStatus"
                                type="select"
                                className="form-select"
                                defaultValue={getCategoryID}
                                onChange={(text) => _setChoiceCategory(text)}
                                value={
                                  getCategoryID
                                }>
                                  <option value="">Lütfen Seçim Yapınız</option>

                                {getCategory.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.Advertesing_Category_Title}</option>
                                ))}

                              </Input>
                              {validation.touched.wsText && validation.errors.wsText ? (
                                <FormFeedback type="invalid">{validation.errors.wsText}</FormFeedback>
                              ) : null}
                            </div>







                            <div className="mb-3">
                              <Label className="form-label">Başlık</Label>
                              <Input
                                name="title"
                                label="title"
                                type="text"
                                placeholder="Reklam Başlığını Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title || ""}
                                invalid={
                                  validation.touched.title &&
                                    validation.errors.title
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.title &&
                                validation.errors.title ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.title}
                                </FormFeedback>
                              ) : null}
                            </div>


                           
                            <div className="mb-3">
                              <Label className="form-label">Sıra No</Label>
                              <Input
                                name="sort"
                                label="sort"
                                type="number"
                                placeholder="Sıra No Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.sort || ""}
                                invalid={
                                  validation.touched.sort &&
                                    validation.errors.sort
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.sort &&
                                validation.errors.sort ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.sort}
                                </FormFeedback>
                              ) : null}
                            </div>


                            <div className="d-flex">
                              <label htmlFor="resume">Aktif Mi?</label>

                              <div className="square-switch">

                                <input
                                  type="checkbox"
                                  id="square-switch1"
                                  className="switch"
                                  defaultChecked={getIsActive}
                                  onChange={() =>
                                    setIsActive(!getIsActive)
                                  }
                                />
                                <label
                                  htmlFor="square-switch1"
                                  data-on-label="Aktif "
                                  data-off-label="Pasif"
                                />
                              </div>

                            </div>




                            <div className="mb-3">
                              <Col xs={12} className="mb-3">
                                <label htmlFor="resume">Görsel</label>
                                <Dropzone
                                  getUploadParams={getUploadParams}
                                  onChangeStatus={handleChangeStatus}
                                  styles={{
                                    dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                                    inputLabelWithFiles: { margin: '20px 3%' }
                                  }}

                                  canRemove={false}
                                  PreviewComponent={Preview}
                                  accept="image/*"
                                />

                              </Col>
                            </div>








                          </Col>
                        </Row>
                        <Row>



                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
